module.exports = __webpack_public_path__ + "img/white_background2.f88ae86a.jpg";